<template>
<div class="introduce_index">
  <transition name="fade">
    <Login class="login-index" v-if="showLogin" @close="closeLogin" @open="openForgetPassword"></Login>
  </transition>
  <transition name="fade">
  <DLG :show="dlgshow" @close="closeDlg" ref="dlg"></DLG>
  </transition>
  <div class="introduce_div_scroll">
    <!--视屏-->
    <div class="introduce_videos position_relative over-hidden">
      <div class="introduce_video position_relative">
        <div class="introduce_video_play position_relative
                    over-hidden">
          <!-- <video-player id="player" class="introduce_video_playV position_absolute
                            position_screen position_center video-js vjs-custom-skin" :options="playerOptions">
            </video-player> -->
          <img src="/static/resource/login_background.jpg" alt="" class="login-background">
        </div>
        <div class="introduce_video_black position_absolute
                        position_screen z_index1"></div>
        <div class="introduce_video_logo position_absolute">
          <img class="img" v-lazy="'/static/images/introduce/write_logo2.png'" alt="蜂巢能源">
        </div>
      </div>
    </div>
    <!-- <div class="ewm">
      <img :src="ewm"/>
    </div> -->
    <!--公司介绍-->
    <div class="introduce_company flex div_backgroundW">
      <div class="introduce_company_left">
        <img class="img" v-lazy="'/static/images/introduce/down2.png'" alt="向下">
      </div>
      <div class="introduce_company_center">
        <div class="company_center position_relative">
          <div class="company_center_text position_absolute
                        position_centerTop">
            <p class="p_title fz-20
                            mr_bottom_16 text-left font_weight_600">
              蜂巢能源
            </p>
            <p class="p_introduce fz-16 text-left">
              储能技术改变了电力传输的实时特性，让电能使用更加灵活，是能源结构转变和电力生产消费方式变革的战略支撑技术
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--智慧储能方案-->
  <div class="introduce_div div_backgroundW
        introduce_div_scroll">
    <div class="introduce_div_Heradar mr_bottom_50
            position_relative" id="s1">
      <div class="Heradar_title fz-38
                text-left text_black mr_bottom_10
                font_weight_600">
        3S智慧储能方案
      </div>
      <div class="Heradar_text fz-20
                text-left text_black">
        匠心打造的3S储能产品
      </div>
      <div class="Heradar_border
                position_absolute flex flex-justify-end
                fz-0">
        <span class="border_sold
                    vertical_align_center mr_right_10"></span>
        <span class="border_span fz-16
                    mr_right_24 vertical_align_center">
          能量流
        </span>
        <span class="border_dotted
                    vertical_align_center mr_right_10"></span>
        <span class="border_span fz-16
                    vertical_align_center">
          信息流
        </span>
      </div>
    </div>
    <div class="introduce_div_module div_backgroundW
            position_relative">
      <img class="flow_img position_absolute
                position_center" v-lazy="'/static/images/introduce/big_data_platform2.png'" alt="智慧储能方案">
    </div>
  </div>
  <!--一直悬浮在低底部的悬浮框-->
  <div class="introduce_div_fixedDiv flex
        flex-justify-end position_fixed div_backgroundW">
    <div class="div_fixedDiv position_absolute
            position_center">
      <a class="div_fixedDivList
                fz-16 text_black
                text-center " href="javascript: void(0);" @click="scrollTop(1)" :class="{active:scrollNumber==1}">
        3S智慧储能方案
      </a>
      <a class="div_fixedDivList
                fz-16 text_black
                text-center " href="javascript: void(0);" @click="scrollTop(2)" :class="{active:scrollNumber==2}">
        3S储能理念
      </a>
      <a class="div_fixedDivList
                fz-16 text_black
                text-center " href="javascript: void(0);" @click="scrollTop(3)" :class="{active:scrollNumber==3}">
        蜂巢能源
      </a>

    </div>
    <div class="buttons normal_button button_bule
                fz-18 text-center color_fff margin_auto_0 cursor_pointer" @click="login()">
      登录
    </div>
  </div>
  <!--3S储能理念-->
  <div class="introduce_div div_backgroundC
         introduce_div_scroll">
    <div class="introduce_div_idea flex" id="s2">
      <div class="introduce_div_ideaDiv
                position_relative">
        <div class="div_ideaDiv_smart position_absolute
                position_center">
          <img class="img" v-lazy="'/static/images/introduce/3s2.png'" alt="3S储能理念">
          <div class="img_div img_div_top
                        position_absolute position_centerLeft
                        cursor_pointer" @click="ideaSelect(0)" :class="{active:ideaNumber==0}">
          </div>
          <div class="img_div img_div_left
                        position_absolute cursor_pointer" @click="ideaSelect(1)" :class="{active:ideaNumber==1}">
          </div>
          <div class="img_div img_div_right
                        position_absolute cursor_pointer" @click="ideaSelect(2)" :class="{active:ideaNumber==2}">
          </div>
        </div>
      </div>
      <div class="introduce_div_ideaDiv
                position_relative">
        <div class="introduce_div_ideaText position_absolute
                position_center">
          <div class="ideaText_title fz-38
                text-left text_black mr_bottom_24 font_weight_600">
            3S储能理念
          </div>
          <div class="ideaText_p fz-16">
            能源互联网背景下，蜂巢能源深度剖析储能业态发展，首发3S储能倡议——储能应以安全Safe、耐用Strong为根本，智能Smart为发展方向，匠心砥砺、深耕不止。
          </div>
          <div class="flex">
            <div class="ideaText_select mr_top_40
                            position_relative" :class="{active:ideaNumber==0}">
              <div class="ideaText_select_title
                                fz-24 text-left text_black
                                font_weight_600 mr_bottom_28">
                <span>
                  {{ideaText.smart.title}}
                </span>
                <span class="text_c">
                  /
                </span>
                <span class="text_c">
                  {{ideaText.smart.titleE}}
                </span>
              </div>
              <div class="ideaText_select_list
                                fz-14 text_black text-left
                                position_relative" v-for="(item, index) in ideaText.smart.text" :key="index" :class="{mr_bottom_16:index!==ideaText.smart.text.length - 1}">
                {{item}}
              </div>
            </div>
            <div class="ideaText_select mr_top_40
                            position_relative" :class="{active:ideaNumber==1}">
              <div class="ideaText_select_title
                                fz-24 text-left text_black
                                font_weight_600 mr_bottom_32">
                <span>
                  {{ideaText.durable.title}}
                </span>
                <span class="text_c">
                  /
                </span>
                <span class="text_c">
                  {{ideaText.durable.titleE}}
                </span>
              </div>
              <div class="ideaText_select_list
                                fz-14 text_black text-left
                                position_relative" v-for="(item, index) in ideaText.durable.text" :key="index" :class="{mr_bottom_16:index!==ideaText.durable.text.length - 1}">
                {{item}}
              </div>
            </div>
            <div class="ideaText_select mr_top_40
                            position_relative" :class="{active:ideaNumber==2}">
              <div class="ideaText_select_title
                                fz-24 text-left text_black
                                font_weight_600 mr_bottom_32">
                <span>
                  {{ideaText.safety.title}}
                </span>
                <span class="text_c">
                  /
                </span>
                <span class="text_c">
                  {{ideaText.safety.titleE}}
                </span>
              </div>
              <div class="ideaText_select_list
                                fz-14 text_black text-left
                                position_relative" v-for="(item, index) in ideaText.safety.text" :key="index" :class="{mr_bottom_16:index!==ideaText.safety.text.length - 1}">
                {{item}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--蜂巢能源-->
  <div class="introduce_div div_backgroundW
         introduce_div_scroll">
    <div class="introduce_div_Heradar mr_bottom_50
            position_relative" id="s3">
      <div class="Heradar_title fz-38
                text-left text_black mr_bottom_10
                font_weight_600">
        蜂巢能源
      </div>
      <div class="Heradar_text fz-20
                text-left text_black">
        因创新而前进
      </div>
    </div>
    <div class="introduce_div_moduleSvolt div_backgroundW position_relative">
      <div class="introduce_div_energy position_absolute
                position_centerTop flex">
        <div class="introduce_div_energyDiv position_relative">
          <img class="img" v-lazy="'/static/images/introduce/mission2.png'" alt="使命">
          <div class="introduce_div_energyText position_absolute
                        position_screen">
            <div class="energyText_title text-left
                            color_fff fz-32 mr_bottom_16
                            font_weight_500">
              使命
            </div>
            <div class="energyText_p text-left
                            color_fff fz-28">
              让人类可以轻松
            </div>
            <div class="energyText_p text-left
                            color_fff fz-28">
              获得和使用可持续能量
            </div>
          </div>
        </div>
        <div class="introduce_div_energyDiv position_relative">
          <img class="img" v-lazy="'/static/images/introduce/values2.png'" alt="价值观">
          <div class="introduce_div_energyText position_absolute
                        position_screen">
            <div class="energyText_title text-left
                            color_fff fz-32 mr_bottom_16
                            font_weight_500">
              价值观
            </div>
            <div class="energyText_p text-left
                            color_fff fz-28">
              因创新而前进
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--底部留空-->
  <div class="introduce_bottom_div"></div>
  <!--全球布局-->
  <div class="introduce_global none">
    <div class="introduce_div_Heradar mr_bottom_50
            position_relative">
      <div class="introduce_div_HeradarHeight
                position_relative">
        <div class="Heradar_title fz-38
                    text-left color_fff mr_bottom_10
                    font_weight_600">
          全球布局
        </div>
        <div class="Heradar_rightGlobal position_absolute
                    flex flex-justify-end">
          <div class="Heradar_rightGlobal_div">
            <div class="rightGlobal_div_number
                            text-center font_weight_600 mr_bottom_8
                            fz-38">
              6
            </div>
            <div class="rightGlobal_div_title fz-16
                            color_fff text-center">
              国家
            </div>
          </div>
          <div class="Heradar_rightGlobal_div
                        position_relative
                        Heradar_rightGlobal_divBorder">
            <div class="Heradar_rightGlobal_div">
              <div class="rightGlobal_div_number
                                text-center font_weight_600 mr_bottom_8
                                fz-38">
                7
              </div>
              <div class="rightGlobal_div_title fz-16
                                color_fff text-center">
                研发中心
              </div>
            </div>
          </div>
          <div class="Heradar_rightGlobal_div">
            <div class="Heradar_rightGlobal_div">
              <div class="rightGlobal_div_number
                                text-center font_weight_600 mr_bottom_8
                                fz-38">
                5
              </div>
              <div class="rightGlobal_div_title fz-16
                                color_fff text-center mr_bottom_6">
                制造基地
              </div>
              <div class="rightGlobal_div_title fz-12
                                color_fff text-center">
                （4个规划中）
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="img_div position_relative">
      <img class="img position_absolute
                position_centerLeft" v-lazy="'/static/images/introduce/global2.png'" alt="全球布局">
    </div>
  </div>
  <!--最佳配置计算页-->
  <div class="introduce_div div_backgroundC none">
    <div class="introduce_div_idea flex">
      <div class="introduce_div_ideaDiv introduce_div_moduleOptimum
                position_relative">
        <div class="introduce_div_ideaText position_absolute
                position_center">
          <div class="ideaText_title fz-38
                text-left text_black mr_bottom_24">
            最佳配置计算
          </div>
          <div class="ideaText_p fz-16">
            能源互联网背景下，蜂巢能源深度剖析储能业态发展，首发3S储能倡议——储能应以安全Safe、耐用Strong为根本，智能Smart为发展方向，匠心砥砺、深耕不止。
          </div>
          <div class="ideaText_button mr_top_60">
            <div class="buttons middle_button button_shadow
                            button_bule fz-18 text-center color_fff">
              点击开始
            </div>
          </div>
        </div>
      </div>
      <div class="introduce_div_ideaDiv introduce_div_moduleOptimum
                position_relative">
        <img class="imgOptimum position_absolute
                    position_center position_absolute " v-lazy="'/static/images/introduce/calculate2.png'" alt="最佳配置计算">
      </div>
    </div>
  </div>
  <div class="recordNo">
    <a href="https://beian.miit.gov.cn/" target="_blank">冀ICP备19018835号</a>
  </div>
</div>
</template>

<script>
import Login from './login'
import DLG from './components/dialog'
export default {
  name: "introduce",
  components: { // 插入文件
    Login,DLG
  },
  data: function () {
    return {
      ewm:'',
      showLogin: false,
      playerOptions: { // 视屏播放
        autoplay: true, //如果true,浏览器准备好时开始回放。
        controls: true, //控制条
        preload: 'auto', //视频预加载
        muted: true, //默认情况下将会消除任何音频。
        loop: true, //导致视频一结束就重新开始。
        language: 'zh-CN',
        aspectRatio: '4:3',
        progressControl: true, // 进度条
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: 'video/mp4',
          src: '/static/resource/svoltadv2.mp4' //你所放置的视频的地址，最好是放在服务器上
        }],
        poster: "", //你的封面地址（覆盖在视频上面的图片）
        width: document.documentElement.clientWidth,
        notSupportedMessage: '此视频暂无法播放，请稍后再试' //允许覆盖Video.js无法播放媒体源时显示的默认信息。
      },
      ideaNumber: 0, // 储能理念切换
      ideaText: { // 储能理念介绍文字
        smart: {
          title: "智能",
          titleE: "smart",
          text: [
            "智能检测、预警、预测",
            "智能控制",
            "智能运维及运行策略优化",
            "智慧用电"
          ]
        },
        durable: {
          title: "耐用",
          titleE: "strong",
          text: [
            "严格按照行业/国际标准制造",
            "车规级品质要求",
            "整车制造经验",
            "制造、运维全生命周期大数据管理"
          ]
        },
        safety: {
          title: "安全",
          titleE: "safety",
          text: [
            "全电芯安全",
            "全方位安全",
            "全寿命安全"
          ]
        }
      },
      scrollNumber: 0, // 下方切换按钮
      dlgshow:false,
    }
  },
  methods: { // 操作方法
  openForgetPassword(){
    this.closeLogin()
    this.dlgshow = true
  },

    closeLogin() {
      this.showLogin = false;
    },
    closeDlg(){
      this.$refs['dlg'].clear()
      this.dlgshow = false;
    },
    login() { // 跳转登录界面
      this.showLogin = true;
    },
    ideaSelect(index) { // 切换选项
      this.ideaNumber = index
    },
    scrollTop(data) {
      this.scrollNumber = data
      this.scrollTo(data)
    },
    initialize() {
      this.scrollNumber = 0
    },
    // 滚动监听器
    onScroll() {
      // 获取所有锚点元素
      const navContents = document.querySelectorAll('.introduce_div_scroll')
      // 所有锚点元素的 offsetTop
      const offsetTopArr = []
      navContents.forEach(item => {
        offsetTopArr.push(item.offsetTop)
      })
      // 获取当前文档流的 scrollTop
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      // 定义当前点亮的导航下标
      let navIndex = 0
      for (let n = 0; n < offsetTopArr.length; n++) {
        // 如果 scrollTop 大于等于第 n 个元素的 offsetTop 则说明 n-1 的内容已经完全不可见
        // 那么此时导航索引就应该是 n 了
        if (scrollTop >= offsetTopArr[n]) {
          navIndex = n
        }
      }
      // 把下标赋值给 vue 的 data
      this.scrollNumber = navIndex
    },
    // 跳转到指定索引的元素
    scrollTo(index) {
      // 获取目标的 offsetTop
      // css选择器是从 1 开始计数，我们是从 0 开始，所以要 +1
      const targetOffsetTop = document.getElementById("s" + index).offsetTop
      // 获取当前 offsetTop
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      // 定义一次跳 50 个像素，数字越大跳得越快，但是会有掉帧得感觉，步子迈大了会扯到蛋
      const STEP = 50
      // 判断是往下滑还是往上滑
      if (scrollTop > targetOffsetTop) {
        // 往上滑
        smoothUp()
      } else {
        // 往下滑
        smoothDown()
      }
      // 定义往下滑函数
      function smoothDown() {
        // 如果当前 scrollTop 小于 targetOffsetTop 说明视口还没滑到指定位置
        if (scrollTop < targetOffsetTop) {
          // 如果和目标相差距离大于等于 STEP 就跳 STEP
          // 否则直接跳到目标点，目标是为了防止跳过了。
          if (targetOffsetTop - scrollTop >= STEP) {
            scrollTop += STEP
          } else {
            scrollTop = targetOffsetTop
          }
          document.body.scrollTop = scrollTop
          document.documentElement.scrollTop = scrollTop
          // 关于 requestAnimationFrame 可以自己查一下，在这种场景下，相比 setInterval 性价比更高
          requestAnimationFrame(smoothDown)
        }
      }
      // 定义往上滑函数
      function smoothUp() {
        if (scrollTop > targetOffsetTop) {
          if (scrollTop - targetOffsetTop >= STEP) {
            scrollTop -= STEP
          } else {
            scrollTop = targetOffsetTop
          }
          document.body.scrollTop = scrollTop
          document.documentElement.scrollTop = scrollTop
          requestAnimationFrame(smoothUp)
        }
      }
    }
  },
  created: function () { // 初始化挂载js
  },
  mounted() { // 初始化请求
    // sessionStorage.removeItem('access_token')
    this.initialize()
    // 监听滚动事件
    window.addEventListener('scroll', this.onScroll, false)
    this.ewm = '/static/images/introduce/ewm-'+process.env.NODE_ENV+'.png'
  },
  destroy() {
    // 必须移除监听器，不然当该vue组件被销毁了，监听器还在就会出错
    window.removeEventListener('scroll', this.onScroll)
  },
  watch: {}
}
</script>

<style lang="scss" scoped>
.login-background {
  width: 1920px;

}
.introduce_div_scroll{
  position:relative;
  .ewm{
    position: absolute;
    top:50px;
    right:50px;
    background:#ffffff;
    display:flex;
    padding:20px;
    img{
      width:158px;
      height:auto;
    }
  }
}
.login-index {
  position: fixed;
  margin: auto;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 700px;
  z-index: 9999;
  // animation-name: bounce;
  // animation-timing-function: ease-in;
  // animation-iteration-count: 1;
  // animation-direction: normal;
  // animation-duration: 2s;
}

>>>.video-js.vjs-fluid {
  height: 100%;
  padding: 0;
}

>>>.video-js .vjs-tech {
  left: 38%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.introduce_videos,
.introduce_video,
.introduce_video_play,
.introduce_video_playV {
  width: 120%;
  height: 72vh;
}

.introduce_videos {
  width: 100%;
  height: 72vh;
}

.introduce_video_playV {
  object-fit: fill;
  height: 138vh;
}

.introduce_video_black {
  background: rgba(0, 13, 34, 0);
}

.introduce_video_logo {
  left: 3.7%;
  top: 4%;
  width: 120px;
  z-index: 2;
}

.introduce_video_logo .img {
  width: 120px;
}

.introduce_company,
.introduce_company_left {
  height: 15vh;
}

.introduce_company {
  width: 100%;
  padding-right: 3.7%;
}

.introduce_company_left,
.introduce_company_left .img {
  height: 15vh;
}

.introduce_company_left {
  width: 11.25%;
}

.introduce_company_left .img {
  width: 100%;
  height: 100%;
}

.introduce_company_center {
  width: calc(100% - 11.25%);

}

.introduce_company_center .company_center {
  padding: 0 4%;
  height: 100%;
}

.introduce_company_center .company_center_text {
  min-height: 100px;
  width: 92%;
  margin: auto 0;
}

.introduce_company_center .company_center_text .p_title {
  height: 26px;
  line-height: 26px;
  color: #2D3B4F;
}

.introduce_company_center .company_center_text .p_introduce {
  max-width: 958px;
  line-height: 22px;
  color: #6C7583;
}

.introduce_company_button {
  max-width: 432px;
  min-width: 192px;
}

.introduce_company_button .buttons {
  width: 192px;
  height: 66px;
  margin: auto 0;
  background: #1559D8;
  border-radius: 44px;
  line-height: 66px;
}

.introduce_company_button .buttons:hover,
.introduce_company_button .buttons:active {
  background: #0F43A2;
}

.introduce_div_backgroundW {
  background: #fff;
}

.introduce_div_backgroundC {
  background: #f8f8f9;
}

.introduce_div_fixedDiv {
  width: 100%;
  height: 90px;
  bottom: 20px;
  left: 0;
  z-index: 10;
  padding: 0 50px;
}

.introduce_div_fixedDiv .div_fixedDiv {
  width: auto;
}

.introduce_div_fixedDiv .div_fixedDiv .div_fixedDivList {
  display: inline-block;
  padding: 0 30px;
  height: 44px;
  line-height: 44px;
  border-radius: 22px;
  margin: 0 4px;
  background: #f8f8f9;
  transition: .15s all ease;
}

.introduce_div_fixedDiv .div_fixedDiv .div_fixedDivList.active,
.introduce_div_fixedDiv .div_fixedDiv .div_fixedDivList:hover {
  background: #1559D8;
  color: #fff;
}

.introduce_div {
  padding: 120px 3.7%;
}

.introduce_div_Heradar,
.introduce_div_module {
  padding: 0 8%;
}

.introduce_div_Heradar {
  height: 90px;
}

.introduce_div_idea {
  padding-top: 20px;
}

.introduce_div_Heradar .Heradar_title,
.introduce_div_ideaText .ideaText_title {
  height: 50px;
  line-height: 50px;
}

.introduce_div_Heradar .Heradar_text,
.introduce_div_Heradar .Heradar_border {
  height: 30px;
  line-height: 30px;
}

.introduce_div_Heradar .Heradar_border {
  right: 8%;
  bottom: 0;
  width: 180px;
}

.introduce_div_Heradar .Heradar_border .border_sold,
.introduce_div_Heradar .Heradar_border .border_dotted {
  margin: 13px 10px 13px 0;
}

.introduce_div_Heradar .Heradar_border .border_sold {
  height: 4px;
  width: 18px;
  background: #CAE2FF;
}

.introduce_div_Heradar .Heradar_border .border_dotted {
  height: 4px;
  width: 18px;
  border-bottom: 4px dashed #92EBDB;
}

.introduce_div_Heradar .Heradar_border .border_span,
.introduce_div_ideaText .ideaText_p {
  color: #576272;
}

.introduce_div_Heradar .Heradar_rightGlobal {
  width: 500px;
  height: 90px;
  right: 0;
  bottom: 0;
}

.introduce_div_Heradar .Heradar_rightGlobal_div {
  width: 162px;
  height: 90px;
}

.introduce_div_Heradar .Heradar_rightGlobal_divBorder:after,
.introduce_div_Heradar .Heradar_rightGlobal_divBorder:before {
  content: '';
  width: 1px;
  height: 42px;
  background: #fff;
  opacity: 0.5;
  top: 24px;
  position: absolute;
}

.introduce_div_Heradar .Heradar_rightGlobal_divBorder:after {
  left: 0;
}

.introduce_div_Heradar .Heradar_rightGlobal_divBorder:before {
  right: 0;
}

.introduce_div_Heradar .Heradar_rightGlobal_div .rightGlobal_div_number {
  color: #3F97FF;
}

.introduce_div_Heradar .Heradar_rightGlobal_div .rightGlobal_div_title {
  height: 16px;
  line-height: 16px;
}

.introduce_div_module {
  height: calc(100vh - 230px);
}

.introduce_div_moduleSvolt {
  height: calc(100vh - 380px);
}

.introduce_div_module .flow_img {
  height: 100%;
  max-width: 84%;
}

.introduce_div_idea {
  width: calc(100% - 8%);
  height: 100%;
}

.introduce_div_ideaDiv.introduce_div_moduleOptimum {
  height: 31.5vh;
  min-height: 340px;
}

.introduce_div_ideaDiv {
  width: 50%;
  max-height: calc(100vh - 90px);
  height: 470px;
  padding: 0 2%;
}

.introduce_div_ideaDiv .div_ideaDiv_smart,
.introduce_div_ideaDiv .div_ideaDiv_smart .img {
  width: 500px;
  height: 470px;
}

.introduce_div_ideaDiv .div_ideaDiv_smart .img_div {
  width: 150px;
  height: 150px;
}

.introduce_div_ideaDiv .div_ideaDiv_smart .img_div_left,
.introduce_div_ideaDiv .div_ideaDiv_smart .img_div_right {
  bottom: 22px;
}

.introduce_div_ideaDiv .div_ideaDiv_smart .img_div_top {
  top: -16px;
}

.introduce_div_ideaDiv .div_ideaDiv_smart .img_div_left {
  left: -16px;
}

.introduce_div_ideaDiv .div_ideaDiv_smart .img_div_right {
  right: -16px;
}

.introduce_div_ideaDiv .div_ideaDiv_smart .img_div_top:hover,
.introduce_div_ideaDiv .div_ideaDiv_smart .img_div_top.active {
  background: url("/static/images/introduce/3s_top2.png") no-repeat -2px 8px;
  background-size: 150px;
}

.introduce_div_ideaDiv .div_ideaDiv_smart .img_div_left:hover,
.introduce_div_ideaDiv .div_ideaDiv_smart .img_div_left.active {
  background: url("/static/images/introduce/3s_left2.png") no-repeat 0 8px;
  background-size: 150px;
}

.introduce_div_ideaDiv .div_ideaDiv_smart .img_div_right:hover,
.introduce_div_ideaDiv .div_ideaDiv_smart .img_div_right.active {
  background: url("/static/images/introduce/3s_right2.png") no-repeat -2px 8px;
  background-size: 150px;
}

.introduce_div_ideaText {
  width: calc(100% - 8%);
}

.introduce_div_ideaText .ideaText_p,
.introduce_div_energyText .energyText_p {
  line-height: 36px;
}

.introduce_div_ideaText .ideaText_select {
  padding-top: 40px;
  border-top: 1px solid #d6d9dd;
  height: 280px;
  width: calc(100% / 3);
  padding: 40px 15px 0 15px;
}

.introduce_div_ideaText .ideaText_select:first-child {
  padding-left: 0;
  width: calc(100% / 3 - 15px);
}

.introduce_div_ideaText .ideaText_select:nth-child(2) {
  width: calc(100% / 3 + 15px);
}

.introduce_div_ideaText .ideaText_select.active {
  display: block;
}

.introduce_div_ideaText .ideaText_select .ideaText_select_title,
.introduce_div_energyText .energyText_title,
.introduce_div_Heradar .Heradar_rightGlobal_div .rightGlobal_div_number {
  height: 40px;
  padding-right: 10px;
  line-height: 40px;
}

.introduce_div_ideaText .ideaText_select .ideaText_select_list {
  height: 28px;
  line-height: 28px;
  padding-left: 20px;
}

.introduce_div_ideaText .ideaText_select .ideaText_select_list:before {
  content: '';
  width: 8px;
  height: 8px;
  background: #1559D8;
  border-radius: 4px;
  left: 6px;
  top: calc(50% - 2px);
  position: absolute;
  transform: translate(-50%, 0);
}

.introduce_div_ideaText .ideaText_button {
  height: 130px;
}

.introduce_div_energy {
  width: 100%;
  padding: 0 8%;
}

.introduce_div_energyDiv {
  width: 48.4%;
}

.introduce_div_energyDiv:first-child {
  margin-right: 3.2%;
}

.introduce_div_energyDiv .img {
  width: 100%;
}

.introduce_div_energyText {
  padding: 6.25%;
  width: 100%;
  height: 100%;
}

.imgOptimum {
  width: 340px;
  height: 340px;
}

.introduce_bottom_div {
  height: 90px;
}

.introduce_global {
  height: 77vh;
  padding: 0 3.7%;
  background: linear-gradient(180deg, #1F3046 0%, #0D1521 100%);
}

.introduce_global .introduce_div_Heradar {
  padding: 6% 8%;
  min-height: 220px;
  max-height: 220px;
  height: auto;
  margin-bottom: 0;
}

.introduce_global .introduce_div_HeradarHeight {
  height: 90px;
}

.introduce_global .img_div {
  height: calc(100% - 220px);
  padding: 0 8%;
}

.introduce_global .img_div .img {
  height: 100%;
  width: calc(100% - 16%);
  bottom: 0;
}

@keyframes bounce {

  from,
  to {
    top: -100%;
    animation-timing-function: ease-out;
  }

  50% {
    top: -50px;
    animation-timing-function: ease-in;
  }

  100% {
    top: 0px;
    animation-timing-function: ease-out;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.recordNo {
  background-color: #fff;
  bottom: 0px;
  width: 100%;
  height: 22px;
  line-height: 20px;
  position: fixed;
  text-align: center;

  a {
    color: #bbb;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login/index.vue